// ── GamesEntry — входы в игры ────────────────────────────────────────────────
// GamesCard — плитка «Игры для запоминания» в разделе «Повторение» (всегда), с числом
// пиявок. LeechNudge — напоминание, когда пиявок накопилось LEECH_PROMPT_AT и больше
// (главная, конец подхода в повторении): «закрепите в играх».

import { useMemo } from 'react';
import Icon from '../Icon';
import { t } from '../i18n';
import { SANS } from '../themes';
import { Button } from '../ui';
import { usePalette } from '../ui/theme';
import { LEECH_PROMPT_AT, MAX_GAME_WORD, MIN_GAME_CARDS, leechesOf, playable } from './leeches';
import { panelSurface } from '../ui/surface';

const useLeechCount = (cards) => useMemo(() => leechesOf(playable(cards)).length, [cards]);

export function GamesCard({ cards, onGames }) {
  const C = usePalette();
  const leeches = useLeechCount(cards);
  const total = useMemo(() => playable(cards).length, [cards]);
  return (
    <div data-tilt="" data-panel="" style={{ ...panelSurface(C), borderRadius: 12,
      padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', fontFamily: SANS }}>
      <span style={{ width: 40, height: 40, borderRadius: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: C.bluePale, color: C.blueDark, flexShrink: 0 }}>
        <Icon n="target" s={20} />
      </span>
      <span style={{ flex: '1 1 180px', minWidth: 0 }}>
        <span style={{ display: 'block', fontSize: 15, fontWeight: 600, color: C.text }}>{t("Игры для запоминания")}</span>
        <span style={{ display: 'block', fontSize: 12.5, color: C.mid, marginTop: 2 }}>
          {leeches ? t("Рой слов, Тир, Лови, Пары · пиявок: {0}", [leeches]) : t("Рой слов, Тир, Лови, Пары")}
        </span>
        {total < MIN_GAME_CARDS && <NotEnough total={total} />}
      </span>
      <span style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {leeches > 0 && <Button onClick={() => onGames(true)}>{t("Пиявки")}</Button>}
        <Button variant="primary" icon="play" onClick={() => onGames(false)} disabled={total < MIN_GAME_CARDS}>{t("Играть")}</Button>
      </span>
    </div>
  );
}

// Почему «Играть» неактивна: сколько карточек годится и что нужно.
export function NotEnough({ total, style }) {
  const C = usePalette();
  return (
    <span style={{ display: 'block', fontSize: 12.5, lineHeight: 1.4, color: C.warmDark, marginTop: 4, ...style }}>
      {t("Чтобы играть, нужно хотя бы {0} карточки со словом и переводом — сейчас {1}. Слово — не длиннее {2} знаков.", [MIN_GAME_CARDS, total, MAX_GAME_WORD])}
    </span>
  );
}

export function LeechNudge({ cards, onGames, style }) {
  const C = usePalette();
  const leeches = useLeechCount(cards);
  if (leeches < LEECH_PROMPT_AT || !onGames) return null;
  return (
    <div role="status" style={{ background: C.warmPale, border: `${C.borderW || 1}px solid ${C.warm}`, borderRadius: 12, padding: '12px 14px',
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', fontFamily: SANS, ...style }}>
      <span style={{ flex: '1 1 200px', minWidth: 0, textAlign: 'left' }}>
        <span style={{ display: 'block', fontSize: 14.5, fontWeight: 600, color: C.text }}>{t("Накопилось пиявок: {0}", [leeches])}</span>
        <span style={{ display: 'block', fontSize: 12.5, color: C.mid, marginTop: 2 }}>{t("Карточки, которые вы часто забываете. Закрепите их в играх.")}</span>
      </span>
      <Button variant="primary" icon="target" onClick={() => onGames(true)}>{t("Закрепить")}</Button>
    </div>
  );
}
